export default class ClientAppConstants {
	static DefaultOrgId: number = 1;
	static AverageErrorScore: number = 13499;
	static DefaultDateFormat: string = "DD-MMM-YY";
}
